import styled, { keyframes } from 'styled-components';
import CheckIcon from '../../../../public/images/icons/check.svg';
import TrashIconSvg from '../../../../public/images/icons/delete.svg';
import SpinnerIcon from '../../../../public/images/icons/spinner.svg';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
    tranform-origin: center center;
  }

  to {
    transform: rotate(360deg);
    tranform-origin: center center;
  }
`;

export const TrashIcon = styled(TrashIconSvg)`
  padding: 3px 0;
  display: block;
  height: 24px;
  width: 24px;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    padding: ${({ theme }) => theme.spacing[4]} 0;
    height: 32px;
    width: 32px;
  }

  path {
    fill: ${({ theme }) => theme.colors.mediumEmphasisBlack};
  }
`;

export const ButtonTrashIcon = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    &:not([disabled]):hover ${TrashIcon} path {
      fill: ${({ theme }) => theme.colors.highEmphasisBlack};
    }
  }

  ${({ disabled, theme }) =>
    disabled &&
    `
    cursor: not-allowed;
    
    ${TrashIcon} path {
      fill: ${theme.colors.disabledBlack};
    }
  `}
`;

export const ButtonGroup = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing[24],

  '> *': {
    flex: 1,
    display: 'grid',

    '&:first-child': {
      marginRight: theme.spacing[8],
    },
  },
}));

export const Spinner = styled(SpinnerIcon)`
  animation-name: ${rotate};
  animation-duration: 700ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;

  &,
  path {
    fill: transparent !important;
    stroke: currentColor;
  }
`;

export const Check = styled(CheckIcon)`
  & path {
    fill: currentColor;
  }
`;
